<template>
    <div v-if="templates.length > 0">
        <select @change="applyTemplate()" v-model="selectedTemplate"
                class="form-control tw-bg-white tw-font-medium tw-mt-4 tw-text-grey tw-w-full">
            <option value="" disabled selected>Select a template</option>
            <option v-for="template in templates" :key="`template-chat-${template.id}`"
                    :value="template">
                {{ template.name }}
            </option>
        </select>

        <modal size="sm" ref="modalLocations" :has-footer="false">
            <template slot="title">Select a location</template>
            <select v-model="selectedLocation" @change="closeModalLocations" class="form-control">
                <option v-for="location in filteredLocations" :key="`location-chat-${location.id}`" :value="location">
                    {{ location.name }}
                </option>
            </select>
        </modal>
    </div>
</template>

<script>
    export default {
        name: "TemplateSelect",

        props: {contact: Object},

        data: () => ({
            templates          : [],
            selectedTemplate   : '',
            tmpSelectedTemplate: '',
            locations          : [],
            selectedLocation   : null,
            hasListener        : false
        }),

        async created() {
            await this.fetchData();
            await this.fetchLocations();
        },

        computed: {
            filteredLocations() {
                if (this.locations && this.tmpSelectedTemplate) {
                    return this.locations.filter((l) => {
                        return this.tmpSelectedTemplate.locations.find((sl) => sl.id === l.id);
                    });
                }
                return [];
            }
        },

        methods: {
            async fetchData() {
                let {data} = await this.$http.get(this.$laroute.route('api.chat.template.index'));

                this.templates = data.data;
            },

            async fetchLocations() {
                let {data} = await this.$http.get(this.$laroute.route('api.global-filters.location', {hide: 'campaigns'}));

                this.locations = data.data;
            },

            async applyTemplate(forceLocation = null) {
                let text = this.selectedTemplate.text;
                text     = text.replace('{{contact_name}}', this.contact.name.split(' ')[0]);
                text     = text.replace('{{company_name}}', this.$root.currentTeam.name);

                if (text.indexOf('{{location_name}}') > -1) {
                    let location = await this.getLocation(forceLocation === null);
                    text         = text.replace('{{location_name}}', location || forceLocation);
                    if (!(location || forceLocation)) return;
                }

                this.$emit('changed', text);
                this.selectedTemplate = '';
            },

            async getLocation(open) {
                if (this.selectedTemplate.locations.length === 1) {
                    return this.selectedTemplate.locations[0].name;
                }

                if (this.filteredLocations.length === 1) {
                    return this.filteredLocations[0].name;
                }

                this.selectedLocation = null;
                if (open) {
                    this.tmpSelectedTemplate = this.selectedTemplate;
                    this.selectedTemplate    = '';
                    this.$refs.modalLocations.open();
                }

                if (!this.hasListener) {
                    this.$refs.modalLocations.$on('hidden', () => {
                        if (this.selectedLocation) {
                            this.selectedTemplate    = this.tmpSelectedTemplate;
                            this.tmpSelectedTemplate = '';
                            this.applyTemplate(this.selectedLocation.name);
                        }
                    });
                    this.hasListener = true;
                }
            },

            closeModalLocations() {
                this.$refs.modalLocations.close();
            }
        }
    }
</script>

